<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Kernkompetenz · Installation</p>

      <h2 class="presentation-page__title">Kernkompetenz Installation</h2>

      <p class="presentation-page__text">
        Eigene Monteure — keine Subunternehmer-Risiken. Terminsicher und versichert.
      </p>

      <div
        class="presentation-page__body presentation-page__body--split presentation-page__body--split-media-40"
      >
        <div class="presentation-page__column presentation-page__column--text">
          <ul class="presentation-page__list">
            <li v-for="item in listItems" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="presentation-page__column presentation-page__column--media">
          <figure class="presentation-page__figure">
            <img
              class="presentation-page__image"
              src="/img/master_presentation/master_presentation_page_18.png"
              alt="Montage einer Photovoltaikanlage auf einem Gewerbedach"
            />
          </figure>
          <p class="presentation-page__image-caption bg-blue">Gewerbedach in Umsetzung</p>
        </div>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage18',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      listItems: [
        'Komplette DC- und AC-Installation',
        'Netzanbindung bis inkl. Hochspannungsebene',
        'Eigene qualifizierte Montageteams',
        'Terminsichere Umsetzung',
        'Einrichtung und Erläuterung aller Monitoringsysteme',
      ],
    };
  },
};
</script>
